export default {
  grouping: {
    groupBy: "Agrupar por",
    assetClass: "Clase de activos",
    currency: "Divisa",
    sector: "Sector",
    region: "Región",
    strategy: "Estrategia",
    uncategorized: "Sin categoría",
  },
  pages: {
    avg: "Media",
    max: "Máx.",
    min: "Mín.",
    footer: {
      page: "Página",
    },
    strategyReport: {
      title: "Propuesta de inversión",
      strategyName: (ctx) =>
        `Nombre de la estrategia: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
      forRecipient: (ctx) => `Para: ${ctx.named("recipient")}`,
      preparedBy: (ctx) => `Preparado por: ${ctx.named("author")}`,
      period: (ctx) => `Período: ${ctx.named("periodStart")} - ${ctx.named("periodEnd")}`,
    },
    tableOfContents: {
      title: "Tabla de contenidos",
    },
    portfolioComposition: {
      title: "Composición de la cartera",
      currencyAlloc: "Asignación por divisa",
      assetClassAlloc: "Asignación por clase de activos",
      sectorAlloc: "Asignación por sector",
      regionAlloc: "Asignación por región",
      composition: "Composición",
    },
    performanceAnalysis: {
      title: "Análisis de rendimiento",
      investGrowth: "Crecimiento de la inversión",
      keyPerfStats: {
        title: "Estadísticas clave de rendimiento",
      },
      histYearyRets: "Rentabilidades anuales históricas",
      histMonthRets: "Rentabilidades mensuales históricas",
    },
    riskAnalysis: {
      title: "Análisis de riesgo",
      drawdownAnalysis: "Análisis de caídas",
      drawdownTable: {
        title: "Tabla de caídas",
        drawdownRank: "Rango de caída",
        startDate: "Fecha de inicio",
        troughDate: "Fecha mínima",
        recoveryDate: "Fecha de recuperación",
      },
    },
    portfolioHoldings: {
      title: "Posiciones de la cartera",
      topHoldings: {
        title: "Principales posiciones",
        name: "Nombre",
        isin: "ISIN",
        currency: "Divisa",
        assetClass: "Clase de activos",
        sector: "Sector",
        region: "Región",
        weight: "Peso",
      },
    },
  },
  productPicker: {
    add: "Añadir",
    searchPlaceholder: "Buscar un producto...",
  },
  report: {
    backToInputs: "Volver a los datos de entrada",
    downloadReport: "Descargar informe",
    taskFailed: (ctx) => `La tarea ${ctx.named("taskName")} ha fallado: ${ctx.named("reason")}`,
  },
  reportInputs: {
    generateReport: "Generar informe",
    fields: {
      general: {
        title: "General",
        portfolioName: "Nombre de la cartera",
        currency: "Divisa",
        author: "Autor",
        recipient: "Destinatario",
        totalCapital: (ctx) => `Capital total (${ctx.named("currency")})`,
        totalCapitalTooltip:
          "Se usa para mostrar el importe invertido de cada posición en la tabla de las principales participaciones, asumiendo este capital al final del período. Dejar vacío para ocultar esa columna.",
      },
      composition: {
        title: "Composición",
        product: "Producto",
        availableFrom: "Disponible desde",
        availableUntil: "Disponible hasta",
        period: "Período",
        fullPeriod: "Período completo",
        weight: "Peso (%)",
        addProduct: "Añadir producto",
        total: "Total",
        selectOneProduct:
          "Seleccione al menos un producto en la composición para poder seleccionar un período.",
        noOverlappingPricePeriod:
          "Los productos seleccionados no tienen un historial de precios común, por lo que no se puede seleccionar un período de informe.",
      },
      miscellaneous: {
        title: "Varios",
        numMonthlyReturns: "Número de años para rentabilidades mensuales históricas",
        numTopHoldings: "Número de posiciones para las principales participaciones",
        numTopHoldingsTooltip: "Dejar vacío para obtener todas las posiciones.",
      },
    },
  },
  weightOptimization: {
    portfoliosWeightsAllocation: "Asignación de pesos de las carteras",
    addProduct: "Añadir producto",
    addPortfolio: "Añadir cartera",
    total: "Total",
    chartsAndTables: {
      buttonText: "Generar gráficos y tablas",
      dataLoadError:
        "Se ha producido un error al cargar los datos. Inténtelo de nuevo o contacte con Alquant AG si el problema persiste.",
      drawdowns: "Caídas",
      performance: "Rendimiento",
      period: "Período",
      periodSelectionCondition:
        "Asegúrese de que cada componente con un peso distinto de cero en cualquier cartera tenga un producto seleccionado.",
      returnToRiskSpace: "Volver al espacio riesgo-rentabilidad",
      selectedPortfolios: "Carteras seleccionadas",
      statistics: "Estadísticas",
      year: "Año",
      yearlyReturns: "Rentabilidades anuales",
    },
    actionTooltip: {
      restoreDefaultPortfolio: (ctx) =>
        `Restaurar la asignación predeterminada de «${ctx.named("portfolioName")}».`,
      optimizeWeight: (ctx) =>
        `Optimizar los pesos de «${ctx.named("portfolioName")}» según las restricciones y objetivos.`,
      cantOptimizeWeight:
        "La optimización requiere un producto seleccionado para cada fila, además de al menos una posición.",
      usePortfolioToGenerateReport: (ctx) =>
        `Generar un informe con la cartera «${ctx.named("portfolioName")}».`,
      cantGenerateReport:
        "La generación del informe requiere un producto seleccionado para cada fila y una asignación total del 100 %.",
      removePortfolio: (ctx) => `Quitar «${ctx.named("portfolioName")}» de la comparación.`,
      cantRemovePortfolio: "Debe quedar al menos una cartera en la comparación.",
    },
    optimizationDialog: {
      title: "Parámetros de optimización",
      objective: "Objetivo",
      period: "Período de optimización",
      bounds: "Límites de asignación",
      addBound: "Añadir límite",
      singlePosition: "Posición individual",
      type: "Tipo",
      target: "Objetivo",
      min: "Mín.",
      max: "Máx.",
      buttonText: "Ejecutar optimización",
      optimization: {
        maxRetWithTargetMaxVol: {
          name: "Maximizar rentabilidad (volatilidad anual objetivo)",
          targetTitle: "Volatilidad anual máxima",
        },
        maxRetWithTargetPainIndex: {
          name: "Maximizar rentabilidad (pain index objetivo)",
          targetTitle: "Pain index máximo",
        },
        maxRetWithTargetMaxDrawdown: {
          name: "Maximizar rentabilidad (caída objetivo)",
          targetTitle: "Caída máxima",
        },
        minVolWithTargetMinRet: {
          name: "Minimizar volatilidad (rentabilidad anual objetivo)",
          targetTitle: "Rentabilidad anual mínima",
        },
        minDrawdownWithTargetMinRet: {
          name: "Minimizar la caída máxima (rentabilidad anual objetivo)",
          targetTitle: "Rentabilidad anual mínima",
        },
        maxSharpe: {
          name: "Maximizar ratio de Sharpe",
        },
        maxSortino: {
          name: "Maximizar ratio de Sortino",
        },
      },
    },
    failedOptimizationDialog: {
      title: "Optimización fallida",
      text: "No se ha encontrado ninguna solución. Las restricciones (valores objetivo y límites de asignación) pueden ser demasiado estrictas.",
    },
  },
};
